import { render } from "./ContextMenuSeparator.vue?vue&type=template&id=27643a0a&ts=true"
import script from "./ContextMenuSeparator.vue?vue&type=script&lang=ts"
export * from "./ContextMenuSeparator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__